import { useState } from 'react';
import TabList from '../Shared/TabList';
import TabListNavItem from '../Shared/TabList/components/TabListNavItem';
import TabListTabContent from '../Shared/TabList/components/TabListTabContent';
import { TranslationService } from '../../services/translation.service';
import QuestionForm from './components/QuestionForm';
import PraiseForm from './components/PraiseForm';
import WishForm from './components/WishForm';
import ComplaintForm from './components/ComplaintForm';
import ErrorReportForm from './components/ErrorReportForm';

function QuestionsAndOpinions() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [showNavItems, setShowNavItems] = useState(true);

  return (
    <div className="questions-and-opinions">
      <TabList
        id="questions-and-opinions-tab-list"
        activeIndex={activeTabIndex}
        renderTabsAsDropdownOnMobile={true}
        dropdownLabel={TranslationService.get('questionsandopinionspage.selectquestionandopinionformlabel')}
        onSelectedChange={setActiveTabIndex}
        navItems={
          showNavItems
          ? [
            <TabListNavItem key={'nav-item-0'}>{TranslationService.get('questionsandopinionspage.question.heading')}</TabListNavItem>,
            <TabListNavItem key={'nav-item-2'}>{TranslationService.get('questionsandopinionspage.praise.heading')}</TabListNavItem>,
            <TabListNavItem key={'nav-item-1'}>{TranslationService.get('questionsandopinionspage.wish.heading')}</TabListNavItem>,
            <TabListNavItem key={'nav-item-3'}>{TranslationService.get('questionsandopinionspage.complaint.heading')}</TabListNavItem>,
            <TabListNavItem key={'nav-item-4'}>{TranslationService.get('questionsandopinionspage.errorreport.heading')}</TabListNavItem>,
          ]
          : []
        }
        tabContents={[
          <TabListTabContent key={'tab-item-0'}>
            <QuestionForm onCompletedChange={(completed) => setShowNavItems(!completed)} />
          </TabListTabContent>,
          <TabListTabContent key={'tab-item-2'}>
            <PraiseForm onCompletedChange={(completed) => setShowNavItems(!completed)} />
          </TabListTabContent>,
          <TabListTabContent key={'tab-item-1'}>
            <WishForm onCompletedChange={(completed) => setShowNavItems(!completed)} />
          </TabListTabContent>,
          <TabListTabContent key={'tab-item-3'}>
            <ComplaintForm onCompletedChange={(completed) => setShowNavItems(!completed)} />
          </TabListTabContent>,
          <TabListTabContent key={'tab-item-4'}>
            <ErrorReportForm onCompletedChange={(completed) => setShowNavItems(!completed)} />
          </TabListTabContent>,
        ]}
      ></TabList>
    </div>
  );
}

export default QuestionsAndOpinions;
